import{halfPI as t}from"../../constants.min.mjs";const r=r=>{if(0===r)return 1;switch(Math.abs(r)/t){case 1:case 3:return 0;case 2:return-1}return Math.cos(r)};export{r as cos};
//# sourceMappingURL=cos.min.mjs.map
